import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CartProvider } from "./contexts/CartContext";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from 'react-helmet-async';
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import OrderPage from "./pages/OrderPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PageTransition from "./components/ui/PageTransition";
import AOS from 'aos';
import 'aos/dist/aos.css';

const LayoutContent = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');
  const isOrderPage = location.pathname === '/order';
  const shouldHideNav = isAdminPage;
  const shouldHideFooter = isAdminPage || isOrderPage;

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-in-out',
    });
  }, []);

  return (
    <>
      {!shouldHideNav && <Navigation />}
      <main>{children}</main>
      {!shouldHideFooter && <Footer />}
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <CartProvider>
          <div className="App">
            <BrowserRouter>
              <LayoutContent>
                <Routes>
                  <Route path="/" element={<PageTransition><Home /></PageTransition>} />
                  <Route path="/order" element={<PageTransition><OrderPage /></PageTransition>} />
                  <Route path="/admin/login" element={<PageTransition><AdminLogin /></PageTransition>} />
                  <Route path="/admin/dashboard" element={<PageTransition><AdminDashboard /></PageTransition>} />
                </Routes>
              </LayoutContent>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </div>
        </CartProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
